<template>
  <div class="tag">
    <div class="d-flex justify-content-between">
      <div class="tag-boxes">
        <div class="d-flex" style="position: absolute; bottom:0;">
          <div v-for="(item ,index) in tagArray" :key="index" @click="doTag(index)" :class="{'tag-active':currentTag === index}" class="tag-body mx-1">{{item}}</div>
        </div>
      </div>
      <div class="d-flex  align-items-center">
        <div v-if="this.$route.name === 'Record.summary.mission'">
          <button v-if="userRole==='Teacher'" @click="downloadExcel" class="btn btn-success">{{$t('export_file')}}</button>
          <select class="mx-2" v-model="missionId">
            <option value="">All</option>
            <option v-for="(item,index) in missionList" :key="index" :value="item.viewId">
              {{item.name}}
            </option>
          </select>
          <select :disabled="mapPointList.length<1" v-model="mapPointId" class="mx-2">
            <option value="">All</option>
            <option v-for="(item,index) in mapPointList" :key="index" :value="item.id">
              {{item.name}}
            </option>
          </select>
          <select :disabled="senceList.length<1" v-model="senceId" class="mx-2">
            <option value="">All</option>
            <option  v-for="(item,index) in senceList" :key="index" :value="item.id">
              {{item.name}}
            </option>
          </select>
        </div>
        <div v-else>
          <div v-if="$route.name !== 'Record.mission.info'">
            <button v-if="userRole==='Teacher'" @click="downloadExcel" class="btn btn-success">{{$t('export_file')}}</button>
            <input v-model="key" @change="searchKey(key)" class="mx-3" style="height:2rem" type="text" placeholder="請輸入學習點名稱">
            <div v-if="searchData.length>1" class="search-box mx-3">
              <div class="box-margin">
                <ul>
                  <li @click="search(item)" v-for="item in searchData" :key="item.viewId">
                    {{item.name}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <button v-if="this.$route.name !== 'Record.summary.mission'&&$route.name !== 'Record.mission.info'" :disabled="key!==''&&key!==name" @click="emitSearch()" class="btn btn-primary m-auto" style="eight: 2rem;line-height:1rem">開始搜尋</button>
        <img class="back-icon my-4" style="height:20px" @click="previousPage" src="../../../../assets/image/icon/close_lesson.png" />
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../../store/api'
export default {

  name: 'labeltag',
  props: {
    tagArray: {
      type: Array,
      default: () => {
        return null
      }
    },
    previous: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    currentTag: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  data () {
    return {
      // currentTag: 0,
      searchData: [],
      key: '',
      keyId: null,
      missionId: '',
      mapPointId: '',
      senceId: '',
      missionList: [],
      mapPointList: [],
      senceList: []
    }
  },
  computed: {
    name () {
      if (this.searchData[0]) {
        return this.searchData[0].name
      } else {
        return this.key
      }
    },
    userRole () {
      return this.$store.state.auth.userRole
    },
    studentId () {
      return this.$store.state.auth.user.id
    }
  },
  watch: {
    key (newVal, oldVal) {
      this.getSceneList()
    },
    missionId (val) {
      this.mapPointId = ''
      this.senceId = ''
      this.getMapPoint(val)
      this.emitSence()
    },
    mapPointId (val) {
      this.getScenes(val)
    },
    senceId (val) {
      this.emitSence(val)
    }
  },
  mounted () {
    if (this.$route.name === 'Record.summary.mission') {
      this.getMissions()
    }
  },
  methods: {
    doTag (mode) {
      if (mode) {
        if (this.userRole === 'Teacher') {
          this.$router.push({name: 'Record.summary.mission'})
        } else {
          console.log('xxx')
          this.$router.push({name: 'Record.mission.info', params: { class: this.$route.params.class, student: this.studentId }})
        }
      } else {
        if (this.userRole === 'Teacher') {
          this.$router.push({name: 'Record.summary.tw', params: { class: this.$route.params.class }})
        } else {
          this.$router.push({name: 'Record.personal.tw', params: { class: this.$route.params.class, student: this.studentId }})
        }
      }
    },
    previousPage () {
      this.$router.go(-1)
    },
    async getSceneList () {
      const { data } = await api.get(`/TravelTaiwan/LearningPoint`, {
        params: {
          key: this.key
        }
      })
      this.searchData = data.data.slice(0, 20)
    },
    search (val) {
      this.key = val.name
      this.keyId = val.viewId
      this.searchData = []
    },
    emitSearch () {
      if (this.$route.name === 'Record.summary.tw') {
        if (this.searchData[0]) {
          this.$emit('getSearch', this.searchData[0].viewId)
        } else {
          this.$emit('getSearch', '')
        }
        this.$emit('getKey', this.key)
        this.searchData = []
      } else {
        if (this.searchData[0]) {
          this.$router.push({name: 'Record.personal.point.tw', params: {point: this.searchData[0].viewId}})
        } else {
          this.$router.push({name: 'Record.personal.tw'})
        }
      }
    },
    searchKey () {
      if (!this.key) {
        this.searchData = []
      } else {
        this.getSceneList()
      }
    },
    async getMissions () {
      const { data } = await api.get(`/TravelTaiwan/Missions`)
      this.missionList = data.data
    },
    async getMapPoint (id) {
      const { data } = await api.get(`/TravelTaiwan/MapPoints`, {params: { missionId: id }})
      this.mapPointList = data.data
    },
    async getScenes (id) {
      const { data } = await api.get(`/TravelTaiwan/Scenes`, {params: { mapPointId: id }})
      this.senceList = data.data
    },
    emitSence (val) {
      this.$emit('getSence', val)
      console.log(val)
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    export2Excel (list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../../../vendor/Export2Excel')
        if (this.currentTag === 0) {
          const tHeader = [ '帳號', '姓名', '學習時間', '星星數' ]
          const filterVal = [ 'userName', 'realName', 'spendTime', 'starCount' ]
          const data = this.formatJson(filterVal, list)
          export_json_to_excel(tHeader, data, '學習紀錄')
        } else {
          const tHeader = [ '帳號', '姓名', '任務名稱', '最高任務評價', '完成時間' ]
          const filterVal = [ 'userName', 'realName', 'sceneName', 'grade', 'spendTime' ]
          const data = this.formatJson(filterVal, list)
          export_json_to_excel(tHeader, data, '學習紀錄')
        }
      })
    },
    async downloadExcel () {
      const groupId = this.$route.params.class
      if (this.currentTag === 0) {
        const { data } = await api.get(`/TravelTaiwan/Record/Group/${groupId}/Students/App/Summary`, {
          params: {
            pageIndex: 1,
            pageSize: 10000
          }
        })
        this.export2Excel(data.data)
      } else {
        const groupId = this.$route.params.class
        const { data } = await api.get(`/TravelTaiwan/Record/Group/${groupId}/Students/MissionScene/Summary`, {
          params: {
            pageIndex: 1,
            pageSize: 10000
          }
        })
        this.export2Excel(data.data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .tag {
    text-align: left;
    border-bottom: #bbbbbb solid 2px;
    .tag-boxes {
      margin-left: 60px;
      position: relative;
    }
  }
  .tag-body {
    white-space:nowrap;
		cursor: pointer;
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px 10px 0 0;
    border-top: 2px #c7c7c7 solid;
    border-right: 2px #c7c7c7 solid;
    border-left: 2px #c7c7c7 solid;
    color: #000000;
		&:hover {
      background-color: #c7c7c7;
    }
	}
  .tag-active {
    border-radius: 10px 10px 0 0;
    background-color: #c7c7c7;
  }
  .back-icon {
    margin-right: 40px;
    margin-left: 40px;
    cursor: pointer;
  }
  .scene-select {
    margin: auto 5px !important;
  }
  @media only screen and (max-width: 768px) {
    .type-selecter {
      position: absolute;
      left: 20%;
    }
  }
  .form_input {
    height: 1.5rem;
  }
  .search-box {
    border: 1px solid rgb(110, 110, 110);
    position:relative;
    .box-margin {
      position: absolute;
      width: 100%;
      max-height: 400px;
      border: rgb(179, 179, 179) 1px solid;
      overflow-y: auto;
      ul {
        padding: 0px;
        background-color: #fff;
        z-index: 100;
        margin: 0;
        li {
          list-style-type: none;
          padding: 5px;
          cursor: pointer;
        }
        li:hover {
          background-color: rgb(70, 4, 250);
          color: white;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// Label.vue?ad006bf6